import React from 'react';
import {render} from 'react-dom';
import postal from 'postal';
import {isQueryValid, createHash} from 'providers/searchResults';
import MetaResultsTabsStore from 'components/meta-results-tabs/store';
import CollapseSearchMaskStore from 'components/CollapsedSearchMask/store';
import createSearchMaskStore from 'components/SearchMask/SearchMaskStore';
import Results from 'components/flights/results';
import DateHelper from 'lib/helpers/date-helper';

const resultsEventsChannel = postal.channel('results-events');
const searchMaskStore = createSearchMaskStore({showRecentQueries: false});

const collapseSearchMaskStore = new CollapseSearchMaskStore();
const resultsTabsStore = new MetaResultsTabsStore(resultsEventsChannel, searchMaskStore.stopLoading);

render((
  <Results
    collapseSearchMaskStore={collapseSearchMaskStore}
    searchMaskStore={searchMaskStore}
    resultsTabsStore={resultsTabsStore}
  />
), document.getElementById('page'));

const makeSearch = (() =>  {
  const currentHash = window.location.hash.substr(1);
  const arrayHash = currentHash.split('/');
  arrayHash.shift();
  const searchQuery = arrayHash.reduce((acc, val, i, array) => {
    if (i === 0) {
      acc.dep = val;
    } else if (i === 1) {
      acc.arr = val;
    } else if (i % 2 === 0) {
      acc[val] = array[i + 1];
    }
    return acc;
  }, {});

  if (!isQueryValid(searchQuery)) {
    return;
  }

  const url = createHash(searchQuery);
  const selectedIndex = resultsTabsStore.tabs.findIndex(({searchQuery}) => searchQuery.url === url);

  const obDate = DateHelper.parseDate(searchQuery.obDate);
  const ibDate = DateHelper.parseDate(searchQuery.ibDate);
  const queryData = {
    ...searchQuery,
    depAirportCode: searchQuery.dep,
    arrAirportCode: searchQuery.arr,
    obDate,
    ibDate,
    obDateFormatted: DateHelper.formatDayDateMonth(obDate),
    ibDateFormatted: DateHelper.formatDayDateMonth(ibDate),
    seatClass: searchQuery.class,
    url
  };
  searchMaskStore.fillWithQuery(queryData);
  collapseSearchMaskStore.setQuery(queryData);

  if (selectedIndex > -1) {
    resultsTabsStore.changeTab(selectedIndex);
    window.location.hash = url;
    searchMaskStore.stopLoading();
    return;
  }

  searchMaskStore.startLoading();

  resultsTabsStore.goToTab({
    ...queryData,
    isRoundtrip: Boolean(searchQuery.isRoundtrip === '1')
  });
});

makeSearch();

window.onhashchange = () => {
  makeSearch();
};
